import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const layoutAuthGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const isAuthenticated = authService.isLoggedIn();
  if (!isAuthenticated) {
    router.navigate([ '/auth' ]);
  }
  return true;
};
